@if (isUpdating$ | async) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
} @else {
  <div class="update-form d-flex">
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
      class="cx-update-password-component col-12 col-md-8 col-lg-6 col-xl-4"
    >
      <h4>Изменение пароля</h4>
      <div class="form-group row">
        <div class="col-md-12">
          <sd-form-field-new label="Новый пароль">
            <input class="form-control" type="password" name="newPassword" formControlName="newPassword" />
          </sd-form-field-new>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <sd-form-field-new [control]="form.get('newPasswordConfirm')" label="Подтвердите пароль">
            <input
              class="form-control"
              type="password"
              name="newPasswordConfirm"
              formControlName="newPasswordConfirm"
            />
          </sd-form-field-new>
        </div>
      </div>
      <div class="form-group row d-flex align-items-center form-buttons">
        <div class="col-md-12">
          <button class="button-update" sdButton [theme]="buttonThemes.Outlined" [size]="buttonSizes.Large">
            Обновить пароль
          </button>
        </div>
      </div>
    </form>
  </div>
}
